import React, { Component } from "react";
import {
  Button,
  TextField,
  IconButton,
  Icon,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import SubirProductos from "../../components/SubirProductos";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { objectAsParams } from "../../helpers";
import Http from "../../Http";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const SECTOR_COFEPRIS_CATALOGS = [
  {
    value: "01",
    label: "Medicamento",
  },
  {
    value: "02",
    label: "Precursores y químicos de uso dual",
  },
  {
    value: "03",
    label: "Psicotrópicos y estupefacientes",
  },
  {
    value: "04",
    label: "Sustancias tóxicas",
  },
  {
    value: "05",
    label: "Plaguicidas y fertilizantes",
  },
];

const FORMA_FARMACEUTICA_CATALOGS = [
  {
    value: "01",
    label: "Tableta",
  },
  {
    value: "02",
    label: "Capsulas",
  },
  {
    value: "03",
    label: "Comprimidos",
  },
  {
    value: "04",
    label: "Grageas",
  },
  {
    value: "05",
    label: "Suspensión",
  },
  {
    value: "06",
    label: "Solución",
  },
  {
    value: "07",
    label: "Emulsión",
  },
  {
    value: "08",
    label: "Jarabe",
  },
  {
    value: "09",
    label: "Inyectable",
  },
  {
    value: "10",
    label: "Crema",
  },
  {
    value: "11",
    label: "Ungüento",
  },
  {
    value: "12",
    label: "Aerosol",
  },
  {
    value: "13",
    label: "Gas medicinal",
  },
  {
    value: "14",
    label: "Gel",
  },
  {
    value: "15",
    label: "Implante",
  },
  {
    value: "16",
    label: "Óvulo",
  },
  {
    value: "17",
    label: "Parche",
  },
  {
    value: "18",
    label: "Pasta",
  },
  {
    value: "19",
    label: "Polvo",
  },
  {
    value: "20",
    label: "Supositorio",
  },
];

const CONDICIONES_ESPECIALES_CATALOGS = [
  {
    value: "01",
    label: "Congelados",
  },
  {
    value: "02",
    label: "Refrigerados",
  },
  {
    value: "03",
    label: "Temperatura controlada",
  },
  {
    value: "04",
    label: "Temperatura ambiente",
  },
];

const MATERIA_PRIMA_CATALOGS = [
  {
    value: "01",
    label: "Materia prima",
  },
  {
    value: "02",
    label: "Materia procesada",
  },
  {
    value: "03",
    label: "Materia terminada(producto terminado)",
  },
  {
    value: "04",
    label: "Materia para la industria manufacturera",
  },
  {
    value: "05",
    label: "Otra",
  },
];

export default class PreguiaProductos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchProducto: {},
      searchProductoOptions: {},
      searchUnidad: {},
      searchUnidadOptions: {},
      productos: [],
    };
  }

  componentDidMount() {
    let productos = [];
    if (this.props.idguia) {
      productos = this.props.productos;
    } else {
      productos = this.props.paquetes.map((paq) => ({
        cantidad: paq.pq_cantidad,
        peso: paq.pq_peso,
        descripcion: paq.pq_descripcion,
        clave_unidad: paq.pq_clave_unidad,
        producto_clave: paq.pq_producto_clave,
      }));
    }
    this.setState({ productos }, () => {
      this.props.onProductosChange(productos);
      this.getFormData({ eg: 1, initial: true });
    });
  }

  getFormData = async ({ eg = null, initial, index, prop }) => {
    let {
      searchProducto = {},
      searchProductoOptions,
      searchUnidad,
      searchUnidadOptions,
      productos,
    } = this.state;
    const params = {};
    if (eg) {
      params["eg"] = eg;
    }
    if (initial) {
      params["initial"] = true;
      if (productos && productos.length > 0) {
        params["clave_productos"] = productos
          .filter((paq) => paq.producto_clave)
          .map((paq) => `'${paq.producto_clave}'`)
          .toString();
        params["clave_unidades"] = productos
          .filter((paq) => paq.clave_unidad)
          .map((paq) => `'${paq.clave_unidad}'`)
          .toString();
      }
    }
    if (prop === "producto_clave") {
      params["productoq"] = searchProducto[index];
    }
    if (prop === "clave_unidad") {
      params["unidadq"] = searchUnidad[index];
    }

    let Res = await Http.get(`preguia/detalle/form?${objectAsParams(params)}`);
    if (!Res.error) {
      if (!initial) {
        if (Res.data.unidades) {
          searchUnidadOptions[index] = Res.data.unidades;
        }
        if (Res.data.productos) {
          searchProductoOptions[index] = Res.data.productos;
        }
      } else {
        if (Res.data.unidades && Res.data.productos) {
          for (let index = 0; index < productos.length; index++) {
            searchUnidadOptions[index] = Res.data.unidades;
            searchProductoOptions[index] = Res.data.productos;
            searchProducto[index] = Res.data.productos.filter(
              (prod) =>
                `${prod.producto_clave}` ===
                `${productos[index].producto_clave}`
            )[0].label;
            searchUnidad[index] = Res.data.unidades.filter(
              (prod) =>
                `${prod.unidad_medida_clave}` ===
                `${productos[index].clave_unidad}`
            )[0].label;
          }
        }
      }
    }
    this.setState({
      searchProductoOptions,
      searchUnidadOptions,
    });
  };

  paqueteAutocompleChange = (i, prop, value) => {
    let { searchProducto, searchUnidad } = this.state;
    if (value !== 0 && value.length > 0) {
      if (prop === "producto_clave") {
        searchProducto[i] = value;
        this.setState({ searchProducto });
      } else if (prop === "clave_unidad") {
        searchUnidad[i] = value;
        this.setState({ searchUnidad });
      }

      if (value.length > 1) {
        this.getFormData({ index: i, prop });
      }
    }
  };

  agregarPaquete = () => {
    let productos = this.state.productos;
    productos.push({
      cantidad: 1,
      peso: 1,
      pdescripcion: "",
      clave_unidad: "",
      producto_clave: "",
    });
    this.setState({ productos });
    this.props.onProductosChange(productos);
  };

  paqueteChange = (i, prop, value) => {
    let productos = this.state.productos;
    productos[i][prop] = value;
    this.setState({ productos });
    this.props.onProductosChange(productos);
  };

  paqueteDelete = (idx) => {
    let productos = this.state.productos.filter((p, i) => i !== idx);
    this.setState({ productos });
    this.props.onProductosChange(productos);
  };

  render() {
    const { formDisabled = false } = this.props;
    const {
      searchUnidad,
      searchUnidadOptions,
      searchProducto,
      searchProductoOptions,
      productos,
    } = this.state;

    return (
      <div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <h3>Productos Detallados</h3>
          <div
            style={{
              width: `50%`,
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <SubirProductos
              onChange={(productos) => {
                this.setState({ productos }, async () => {
                  this.props.onProductosChange(productos);
                  this.getFormData({ eg: 1, initial: true });
                });
              }}
            />
            <Button color="primary" onClick={this.agregarPaquete}>
              Agregar Producto
            </Button>
          </div>
        </div>
        {productos.map((paquete, i) => (
          <div style={{ display: "flex" }} className="paq in" key={i}>
            <div style={{ minWidth: "150px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                type="number"
                label="*Cantidad"
                value={paquete.cantidad}
                variant="outlined"
                inputProps={{ min: 1 }}
                onChange={(e) => {
                  this.paqueteChange(i, "cantidad", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "150px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                type="number"
                label="*Peso"
                value={paquete.peso}
                variant="outlined"
                inputProps={{ min: 1 }}
                onChange={(e) => {
                  this.paqueteChange(i, "peso", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "150px", margin: "5px" }}>
              <Autocomplete
                style={{ width: "100%" }}
                disabled={formDisabled}
                className="form-field"
                inputValue={searchUnidad[i] ? searchUnidad[i] : ""}
                getOptionLabel={(option) => (option ? option.label || "" : "")}
                options={searchUnidadOptions[i] ? searchUnidadOptions[i] : []}
                onInputChange={(e, newInputValue) => {
                  console.log("newInputValue", newInputValue);
                  this.paqueteAutocompleChange(
                    i,
                    "clave_unidad",
                    newInputValue
                  );
                }}
                value={paquete["clave_unidad"] ? paquete["clave_unidad"] : ""}
                onChange={(event, newValue) => {
                  this.paqueteChange(
                    i,
                    "clave_unidad",
                    newValue ? newValue.id : ""
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`*Unidad`}
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>
            <div style={{ minWidth: "150px", margin: "5px" }}>
              <Autocomplete
                disabled={formDisabled}
                className="form-field"
                value={
                  paquete["producto_clave"] ? paquete["producto_clave"] : ""
                }
                onChange={(event, newValue) => {
                  this.paqueteChange(
                    i,
                    "producto_clave",
                    newValue ? newValue.id : ""
                  );
                }}
                inputValue={searchProducto[i] ? searchProducto[i] : ""}
                getOptionLabel={(option) => (option ? option.label || "" : "")}
                options={searchProductoOptions[i] || []}
                onInputChange={(e, newInputValue) => {
                  this.paqueteAutocompleChange(
                    i,
                    "producto_clave",
                    newInputValue
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`*Producto`}
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>
            <div style={{ minWidth: "150px", margin: "5px" }}>
              <TextField
                disabled={formDisabled}
                label="*Descripción"
                multiline
                fullWidth
                minRows="1"
                value={paquete.descripcion}
                onChange={(e) => {
                  this.paqueteChange(i, "descripcion", e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <FormControl variant="outlined" className="form-field">
                <InputLabel id="cofepris-label">SectorCOFEPRIS</InputLabel>
                <Select
                  disabled={formDisabled}
                  fullWidth
                  value={
                    paquete["SectorCOFEPRIS"] ? paquete["SectorCOFEPRIS"] : ""
                  }
                  onChange={(e) => {
                    this.paqueteChange(i, "SectorCOFEPRIS", e.target.value);
                  }}
                >
                  {SECTOR_COFEPRIS_CATALOGS.map((option, i) => (
                    <MenuItem
                      value={option.value}
                      key={`grupo-${option.value}`}
                    >
                      {`${option.value} - ${option.label}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ minWidth: "220px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="NombreIngredienteActivo"
                value={paquete.NombreIngredienteActivo}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(
                    i,
                    "NombreIngredienteActivo",
                    e.target.value
                  );
                }}
              />
            </div>
            <div style={{ minWidth: "150px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="NomQuimico"
                value={paquete.NomQuimico}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "NomQuimico", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "250px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="DenominacionGenericaProd"
                value={paquete.DenominacionGenericaProd}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(
                    i,
                    "DenominacionGenericaProd",
                    e.target.value
                  );
                }}
              />
            </div>
            <div style={{ minWidth: "250px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="DenominacionDistintivaProd"
                value={paquete.DenominacionDistintivaProd}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(
                    i,
                    "DenominacionDistintivaProd",
                    e.target.value
                  );
                }}
              />
            </div>
            <div style={{ minWidth: "150px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="Fabricante"
                value={paquete.Fabricante}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "Fabricante", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <FormControl className="form-field">
                  <KeyboardDateTimePicker
                    disableToolbar
                    variant="inline"
                    disabled={formDisabled}
                    autoOk
                    label={`FechaCaducidad`}
                    inputVariant="outlined"
                    value={paquete.FechaCaducidad || null}
                    format="dd/MM/yyyy"
                    onChange={(e) => { this.paqueteChange(i, "FechaCaducidad", e); }}
                  />
                </FormControl>
              </MuiPickersUtilsProvider>
            </div>
            <div style={{ minWidth: "170px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="LoteMedicamento"
                value={paquete.LoteMedicamento}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "LoteMedicamento", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <FormControl variant="outlined" className="form-field">
                <InputLabel id="cofepris-label">FormaFarmaceutica</InputLabel>
                <Select
                  disabled={formDisabled}
                  fullWidth
                  value={
                    paquete["FormaFarmaceutica"]
                      ? paquete["FormaFarmaceutica"]
                      : ""
                  }
                  onChange={(e) => {
                    this.paqueteChange(i, "FormaFarmaceutica", e.target.value);
                  }}
                >
                  {FORMA_FARMACEUTICA_CATALOGS.map((option, i) => (
                    <MenuItem
                      value={option.value}
                      key={`grupo-${option.value}`}
                    >
                      {`${option.value} - ${option.label}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ minWidth: "250px", margin: "5px" }}>
              <FormControl variant="outlined" className="form-field">
                <InputLabel id="cofepris-label">
                  CondicionesEspTransp
                </InputLabel>
                <Select
                  disabled={formDisabled}
                  fullWidth
                  value={
                    paquete["CondicionesEspTransp"]
                      ? paquete["CondicionesEspTransp"]
                      : ""
                  }
                  onChange={(e) => {
                    this.paqueteChange(
                      i,
                      "CondicionesEspTransp",
                      e.target.value
                    );
                  }}
                >
                  {CONDICIONES_ESPECIALES_CATALOGS.map((option, i) => (
                    <MenuItem
                      value={option.value}
                      key={`grupo-${option.value}`}
                    >
                      {`${option.value} - ${option.label}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ minWidth: "300px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="RegistroSanitarioFolioAutorizacion"
                value={paquete.RegistroSanitarioFolioAutorizacion}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(
                    i,
                    "RegistroSanitarioFolioAutorizacion",
                    e.target.value
                  );
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="PermisoImportacion"
                value={paquete.PermisoImportacion}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "PermisoImportacion", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="FolioImpoVUCEM"
                value={paquete.FolioImpoVUCEM}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "FolioImpoVUCEM", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="NumCAS"
                value={paquete.NumCAS}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "NumCAS", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="RazonSocialEmpImp"
                value={paquete.RazonSocialEmpImp}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "RazonSocialEmpImp", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "250px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="NumRegSanPlagCOFEPRIS"
                value={paquete.NumRegSanPlagCOFEPRIS}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(
                    i,
                    "NumRegSanPlagCOFEPRIS",
                    e.target.value
                  );
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="DatosFabricante"
                value={paquete.DatosFabricante}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "DatosFabricante", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="DatosFormulador"
                value={paquete.DatosFormulador}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "DatosFormulador", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="DatosMaquilador"
                value={paquete.DatosMaquilador}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "DatosMaquilador", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="UsoAutorizado"
                value={paquete.UsoAutorizado}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "UsoAutorizado", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <FormControl variant="outlined" className="form-field">
                <InputLabel id="cofepris-label">TipoMateria</InputLabel>
                <Select
                  disabled={formDisabled}
                  fullWidth
                  value={paquete["TipoMateria"] ? paquete["TipoMateria"] : ""}
                  onChange={(e) => {
                    this.paqueteChange(i, "TipoMateria", e.target.value);
                  }}
                >
                  {MATERIA_PRIMA_CATALOGS.map((option, i) => (
                    <MenuItem
                      value={option.value}
                      key={`grupo-${option.value}`}
                    >
                      {`${option.value} - ${option.label}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                fullWidth
                disabled={formDisabled}
                label="DescripcionMateria"
                value={paquete.DescripcionMateria}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "DescripcionMateria", e.target.value);
                }}
              />
            </div>
            <div style={{ minWidth: "200px", margin: "5px" }}>
              <TextField
                type="number"
                fullWidth
                disabled={formDisabled}
                label="ValorMercancia"
                value={paquete.ValorMercancia}
                variant="outlined"
                onChange={(e) => {
                  this.paqueteChange(i, "ValorMercancia", e.target.value);
                }}
              />
            </div>
            <div
              style={{ width: "55px", margin: "5px" }}
              className=" preguia-detalles-delete"
            >
              <IconButton
                onClick={() => {
                  this.paqueteDelete(i);
                }}
                disabled={formDisabled}
              >
                <Icon>remove_circle</Icon>
              </IconButton>
            </div>
          </div>
        ))}
      </div>
    );
  }
}
